// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2729":"20e25ed1","3138":"e432fe9c","8199":"20e25ed1","9546":"0e9e9019","9890":"995100ff"}[chunkId] + ".chunk.css";
};